export default [
  {
    path: '/customer',
    name: 'principal',
    component: () => import('@/views/apps/customer/principal/principalCustomer.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },
  {
    path: '/customer/chat-customer',
    name: 'customer-chat',
    component: () => import('@/views/apps/customer/chat/AppChat.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },
  {
    path: '/customer/favoritos',
    name: 'favoritos',
    component: () => import('@/views/apps/customer/favoritos/favoritosCustomers.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/agenda',
    name: 'agenda',
    component: () => import('@/views/apps/customer/agenda/agendaCustomer.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/post/:id',
    name: 'post',
    component: () => import('@/views/apps/customer/posts/viewPost.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/specialists/:id',
    name: 'specialist-view',
    component: () => import('@/views/apps/customer/principal/especialist/viewSpecialist.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/confirm-registration/:id',
    name: 'confirm-registration',
    component: () => import('@/views/apps/customer/principal/confirmRegistration.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/detail/:id',
    name: 'detail',
    component: () => import('@/views/apps/customer/principal/especialist/detailsSpecialist.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/horario/:specialist_id',
    name: 'customer-horario',
    component: () => import('@/views/apps/customer/principal/especialist/selectTime.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/novo-cartao',
    name: 'customer-novo-cartao',
    component: () => import('@/views/apps/customer/cartao/FormNovoCartao.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/create',
    name: 'customer-create',
    component: () => import('@/views/apps/customer/createCustomer/Index.vue'),
    meta: {
      layout: 'full',
      requiresAuth: false,
    },
  },

  {
    path: '/customer/perfil',
    name: 'customer-perfil',
    component: () => import('@/components/perfil/AccountSetting.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/swiper',
    name: 'swiper',
    component: () => import('@/views/apps/customer/principal/components/SwiperCenteredSlides.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },
  {
    path: '/customer/plantao',
    name: 'plantao',
    component: () => import('@/views/apps/customer/agenda/medicalDutyCustomer.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },
  {
    path: '/customer/area-paciente',
    name: 'patient-area',
    component: () => import('@/views/apps/customer/patientArea/patientArea.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },

  {
    path: '/customer/area-paciente/historico-exame',
    name: 'patient-history-exam',
    component: () => import('@/views/apps/customer/patientArea/patientAreaView/examHistoryView.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },

  },

  {
    path: '/customer/prescricao',
    name: 'prescription',
    component: () => import('@/views/apps/customer/patientArea/patientAreaView/prescription.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
      pageTitle: 'Prescrição',
    },

  },

  {
    path: '/customer/pronto-atendimento',
    name: 'pronto-atendimento',
    component: () => import('@/views/apps/customer/queue/ServiceQueue.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },
  },
  {
    path: '/customer/calls/:id?',
    name: 'calls-customer',
    component: () => import('@/components/videoCall/agoraVideoCall.vue'),
    meta: {
      layout: 'full',
      resource: 'customer',
      action: 'manage',
    },

  },
]
